"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6151],{

/***/ 16151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgShower = function SvgShower(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 13 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M13 6.334a1 1 0 0 0-1-1h-1V5a.333.333 0 0 0-.334-.334H8A.333.333 0 0 0 7.666 5v.334H2.333V1.57a.903.903 0 0 1 1.71-.403l.325.65a1.644 1.644 0 0 0-.702 1.34v.51a.333.333 0 0 0 .483.298l2.667-1.333a.333.333 0 0 0 0-.596l-.738-.369a1.667 1.667 0 0 0-1.11-.133c0-.006 0-.01-.004-.016L4.64.868a1.57 1.57 0 0 0-2.974.702v3.764h-.333A1 1 0 0 0 1 7.273V9a2.327 2.327 0 0 0 1.179 2.016l-.415.414a.334.334 0 1 0 .472.472l.618-.62c.158.034.318.05.479.05H10c.16 0 .32-.016.478-.05l.619.62a.334.334 0 0 0 .472-.472l-.415-.414A2.327 2.327 0 0 0 12.333 9V7.273a1 1 0 0 0 .667-.94ZM5.78 2.267l.14.07-1.587.79a1 1 0 0 1 1.447-.866v.006Zm2.553 5.734h2v.666h-2v-.666Zm0-2.667h2v2h-2v-2Zm-7 .667h6.333v.666H1.333a.333.333 0 0 1 0-.667Zm10.333 3A1.667 1.667 0 0 1 10 10.667H3.333a1.667 1.667 0 0 1-1.667-1.666V7.334h6V9A.333.333 0 0 0 8 9.334h2.666A.333.333 0 0 0 11 9V7.334h.666V9ZM12 6.667h-1V6h1a.333.333 0 1 1 0 .667Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgShower);

/***/ })

}]);